import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const VideoEditingIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-videoEditing"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M45.6182942,0.104638375 L19.8706082,3.72373456 C18.229493,3.95475075 17.0865809,5.47152126 17.3175629,7.11239352 L18.013537,12.0632089 C18.0904176,12.6100997 18.5960729,12.9911264 19.142967,12.9142689 L48.850967,8.73926893 C49.3978938,8.66240683 49.7789483,8.15671467 49.702063,7.60979114 L49.0060371,2.65860648 C48.7751066,1.01810034 47.2589492,-0.124813379 45.6182942,0.104638375 Z M46.0123908,2.07577841 C46.5128394,2.06410484 46.9540151,2.42912549 47.0255629,2.93739352 L47.582,6.897 L19.855,10.794 L19.298063,6.83379114 C19.2210497,6.28669623 19.6018894,5.78127987 20.1491935,5.70423707 L45.8959918,2.08526544 L46.0123908,2.07577841 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M49,12 L19,12 C18.4477153,12 18,12.4477153 18,13 L18,31 C18,32.6572847 19.3427153,34 21,34 L47,34 C48.6572847,34 50,32.6572847 50,31 L50,13 C50,12.4477153 49.5522847,12 49,12 Z M20,14 L48,14 L48,31 C48,31.5527153 47.5527153,32 47,32 L21,32 L20.8832993,31.9932784 C20.385669,31.9355643 20,31.5132356 20,31 L20,14 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="48 19 48 20 20 20 20 19"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="27.475 13.318 28.182 14.025 22.525 19.682 21.818 18.975"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="33.475 13.318 34.182 14.025 28.525 19.682 27.818 18.975"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="39.475 13.318 40.182 14.025 34.525 19.682 33.818 18.975"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="45.475 13.318 46.182 14.025 40.525 19.682 39.818 18.975"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="39.025 1.818 44.682 7.475 43.975 8.182 38.318 2.525"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="33.525 2.818 39.182 8.475 38.475 9.182 32.818 3.525"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="28.025 3.818 33.682 9.475 32.975 10.182 27.318 4.525"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="22.025 4.318 27.682 9.975 26.975 10.682 21.318 5.025"
        />
        <path
          d="M37.6594,25.4223 C38.1024,25.6823 38.1024,26.3233 37.6594,26.5833 L34.8244,28.2483 L32.0014,29.9053 C31.5584,30.1653 31.0004,29.8453 31.0004,29.3313 L31.0004,26.0033 L31.0004,22.6603 C31.0004,22.1523 31.5514,21.8373 31.9894,22.0943 L34.8244,23.7583 L37.6594,25.4223 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
